const normalizeUrl = (url) => {
  if (!url) return '';
  return String(url).trim().replace(/\/+$/, '');
};

// Hosts managed by the Emergent platform. When the frontend is being
// served from one of these, the backend lives at the same origin and we
// must NOT call out to the production env URL (or any other env value
// baked into the build). This is what makes the build artifact safe to
// share between preview pods and the production custom-domain deploy.
const EMERGENT_DOMAIN_SUFFIXES = ['.emergent.host', '.emergentagent.com'];

const isEmergentOrigin = (hostname) => {
  if (!hostname) return false;
  return EMERGENT_DOMAIN_SUFFIXES.some((suffix) => hostname.endsWith(suffix));
};

export const getBackendBaseUrl = () => {
  const envUrl = normalizeUrl(process.env.REACT_APP_BACKEND_URL);

  // SSR / non-browser fallback — only the env value is available.
  if (typeof window === 'undefined') {
    return envUrl;
  }

  const originUrl = normalizeUrl(window.location.origin);
  if (!envUrl) {
    return originUrl;
  }

  try {
    const envHost = new URL(envUrl).hostname;
    const originHost = new URL(originUrl).hostname;

    // Same host — nothing to do, env URL already matches.
    if (envHost === originHost) {
      return envUrl;
    }

    // Emergent-managed origin (preview pods, .emergent.host shadow
    // domains, *.emergentagent.com) — always route to same-origin.
    // The env value in this build is whatever the production deploy
    // baked in (e.g. https://bayenah.com); preview must NOT call that.
    if (isEmergentOrigin(originHost)) {
      return originUrl;
    }
  } catch {
    return envUrl;
  }

  return envUrl;
};
